import { format, subWeeks } from "date-fns"
import { HeartHandshake, LayoutDashboard } from "lucide-react"
import { useGetBiMetricsQuery } from "modules/backoffice/hooks/bi/useGetBiMetricsQuery"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { TimeDimensionEnum } from "schema"
import { BackofficeSection } from "../BackofficeSection"
import { BackofficeBiDisplay } from "../bi/BackofficeBiDisplay"
import { BackofficeShopifyMetafieldsAuditButton } from "../shopifyMetafieldsAudit/BackofficeShopifyMetafieldsAuditButton"

type Props = {
  organizationId: string
  companyId: string
  showCards?: boolean
}

export const BackofficeCompanySections = ({
  organizationId,
  companyId,
  showCards = true,
}: Props) => {
  const { t } = useTranslation()

  const defaultTo = useMemo(() => new Date(), [])
  const defaultFrom = useMemo(() => subWeeks(defaultTo, 2), [defaultTo])

  const { data: biData, isPending: isBiPending } = useGetBiMetricsQuery({
    companyId,
    from: format(defaultFrom, "dd/MM/yyyy"),
    to: format(defaultTo, "dd/MM/yyyy"),
  })

  const companyCards = [
    {
      icon: HeartHandshake,
      title: t("backoffice.customers.title"),
      url: "/backoffice/organizations/$id/companies/$companyId/customers/list" as const,
      params: { id: organizationId, companyId },
    },
    {
      icon: LayoutDashboard,
      title: t("backoffice.canonicalTopics.title"),
      url: "/backoffice/organizations/$id/companies/$companyId/canonical-topics/list" as const,
      params: { id: organizationId, companyId },
    },
  ]

  return (
    <>
      {showCards && <BackofficeSection items={companyCards} />}
      <div className="flex">
        <BackofficeShopifyMetafieldsAuditButton companyId={companyId} />
      </div>
      <BackofficeBiDisplay
        data={biData}
        isPending={isBiPending}
        range={{ from: defaultFrom, to: defaultTo }}
        timeDimension={TimeDimensionEnum.Day}
      />
    </>
  )
}
